import { request } from '@/api/index';
import { getTimestamp } from '@/api/common';
import {
  LeadResquest,
  LeadResponse,
  SendPhoneCode,
  PosterBuryingPointReq,
  PosterBuryingPointRes,
  ExpandSubjectsLabelReq,
  ExpandSubjectsLabelRes,
  StudentInformationRes,
  StudentInformationReq,
  EmailVerificationCodeRequest,
  EmailVerificationCodeResponse,
  ChannelResponse,
  StudentCodeReq,
  StudentInformationBaseReq,
  StudentInformationBaseRes,
  SendVoiceCode,
  VoiceVerificationCodeRequest,
  IGradeDateReq,
  IGradeDateRes,
} from './interface/lead';

// 创建线索
export const createLead = (params: LeadResquest) => {
  return request.post<LeadResponse, LeadResponse>('/public/lead', params, {
    needAuth: true,
  });
};

// 海报事件埋点
export const sendPosterBuryingPoint = (params: PosterBuryingPointReq) => {
  return request.post<PosterBuryingPointRes, PosterBuryingPointRes>(`/public/poster/center/rio/lead/data`, {
    ...params,
  });
};

// 扩科打标签接口
export const expandSubjectsLabel = (params: ExpandSubjectsLabelReq) => {
  return request.post<ExpandSubjectsLabelRes, ExpandSubjectsLabelRes>(`/public/lead/intention`, {
    ...params,
  });
};
// 扩科打标签接口 不提醒
export const expandSubjectsLabelNoRemind = (params: ExpandSubjectsLabelReq) => {
  return request.post<ExpandSubjectsLabelRes, ExpandSubjectsLabelRes>(
    `/public/lead/intention`,
    {
      ...params,
    },
    { skipErrorHandler: true },
  );
};

// 通过学号查询学生信息
export const getStudentInformation = (params: StudentInformationReq) => {
  return request.post<StudentInformationRes, StudentInformationRes>(`/public/student/baseInfo/${params.code}`);
};

// 通过学号查询学生信息
export const getStudentInformationBase = (params: StudentInformationBaseReq) => {
  return request.post<StudentInformationBaseRes, StudentInformationBaseRes>(`/public/track/baseInfo`, params);
};

// 发送短信验证码
export const sendPhoneVerificationCode = (params: SendPhoneCode) => {
  return getTimestamp().then((res) => {
    return request.put('/public/sms/send', params, {
      signature: true,
      timestamp: res,
    });
  });
};

/**
 * 发送短信验证码（安全）
 * 2025-04-17 新增 , 使用统一 useCaptcha 组件进行的安全验证
 */
export const sendPhoneVerificationCodeSecured = (params: SendPhoneCode, headers: any) => {
  return getTimestamp().then((res) => {
    return request.put('/public/sms/send/secured', params, {
      signature: true,
      timestamp: res,
      signatureHeaders: headers,
    });
  });
};

// 验证短信验证码
export const verifyPhoneVerificationCode = (data: EmailVerificationCodeRequest) => {
  return request.post<EmailVerificationCodeResponse, EmailVerificationCodeResponse>('/public/sms/verification', data);
};

// 发送语音验证码
export const sendVoiceVerificationCode = (params: SendVoiceCode) => {
  return getTimestamp().then((res) => {
    return request.put('/public/sms/send/voice', params, {
      signature: true,
      timestamp: res,
    });
  });
};

/**
 * 发送语音验证码（安全）
 * 2025-04-17 新增 , 使用统一 useCaptcha 组件进行的安全验证
 */
export const sendVoiceVerificationCodeSecured = (params: SendVoiceCode, headers: any) => {
  return getTimestamp().then((res) => {
    return request.put('/public/sms/send/voice/secured', params, {
      signature: true,
      timestamp: res,
      signatureHeaders: headers,
    });
  });
};

// 验证语音验证码
export const verifyVoiceVerificationCode = (data: VoiceVerificationCodeRequest) => {
  return request.post<EmailVerificationCodeResponse, EmailVerificationCodeResponse>(
    '/public/sms/verification/voice',
    data,
  );
};

export const getJsonNode = (id: string) => {
  return request.get<ChannelResponse, ChannelResponse>(`/public/ref/json_node/${id}`);
};

// 约课获取学生学号
export const getOldUserStudentCode = (params: StudentCodeReq) => {
  return request.post<any, any>('/public/poster/center/track/info/data/', params);
};

// 获取年级
export const getGradeDate = (params: IGradeDateReq) => {
  return request.post<IGradeDateRes, IGradeDateRes>('/public/ref/grade-year/search', params);
};

// 查询是否有约课记录
// true：可以约课
// false：已存在已完课记录，不允许
export const haveAppointmentRecord = (id: string) => {
  return request.get<boolean, boolean>(`/public/reserve/canReserveTrailClass?trackId=${id}`);
};
